import { mutatorAction } from 'satcheljs';
import AutoLabelViewState from '../../store/schema/clp/AutoLabelViewState';

export default mutatorAction(
    'updateAutoLabelViewState',
    <T extends keyof AutoLabelViewState>(
        viewState: AutoLabelViewState,
        fieldName: T,
        value: AutoLabelViewState[T]
    ) => {
        viewState[fieldName] = value;
    }
);
